import React from 'react';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="min-h-[88vh] flex items-center justify-center text-center px-[5%] py-[60px] relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #FFF0F5 0%, #F5F0FF 50%, #F0FFF8 100%)',
      }}
    >
      {/* Animated Blobs */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute rounded-full opacity-45 animate-[float_6s_ease-in-out_infinite]"
          style={{
            width: '400px',
            height: '400px',
            background: 'var(--pink)',
            top: '-100px',
            left: '-100px',
            filter: 'blur(60px)',
            animationDelay: '0s',
          }}
        />
        <div
          className="absolute rounded-full opacity-45 animate-[float_6s_ease-in-out_infinite]"
          style={{
            width: '350px',
            height: '350px',
            background: 'var(--lavender)',
            bottom: '-80px',
            right: '-80px',
            filter: 'blur(60px)',
            animationDelay: '2s',
          }}
        />
        <div
          className="absolute rounded-full opacity-45 animate-[float_6s_ease-in-out_infinite]"
          style={{
            width: '250px',
            height: '250px',
            background: 'var(--mint)',
            bottom: '20%',
            left: '20%',
            filter: 'blur(60px)',
            animationDelay: '4s',
          }}
        />
      </div>

      {/* Floating Emojis */}
      <div className="absolute inset-0 pointer-events-none">
        <span
          className="absolute text-4xl opacity-70 animate-[floatEmoji_5s_ease-in-out_infinite]"
          style={{ top: '15%', left: '8%', animationDelay: '0s' }}
        >
          🫧
        </span>
        <span
          className="absolute text-4xl opacity-70 animate-[floatEmoji_5s_ease-in-out_infinite]"
          style={{ top: '25%', right: '8%', animationDelay: '1s' }}
        >
          🐰
        </span>
        <span
          className="absolute text-4xl opacity-70 animate-[floatEmoji_5s_ease-in-out_infinite]"
          style={{ bottom: '25%', left: '12%', animationDelay: '2s' }}
        >
          🌈
        </span>
        <span
          className="absolute text-4xl opacity-70 animate-[floatEmoji_5s_ease-in-out_infinite]"
          style={{ bottom: '20%', right: '12%', animationDelay: '3s' }}
        >
          ⭐
        </span>
        <span
          className="absolute text-4xl opacity-70 animate-[floatEmoji_5s_ease-in-out_infinite]"
          style={{ top: '50%', left: '4%', animationDelay: '1.5s' }}
        >
          🍓
        </span>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[720px]">
        <span
          className="inline-block font-extrabold text-sm px-[18px] py-[6px] rounded-full mb-5 tracking-wider animate-[bounceIn_0.6s_both]"
          style={{
            background: 'var(--yellow)',
            color: 'var(--dark)',
          }}
        >
          ✨ New arrivals every week!
        </span>

        <h1
          className="fredoka mb-5 leading-tight animate-[slideUp_0.7s_0.1s_both]"
          style={{
            fontSize: 'clamp(2.8rem, 6vw, 5rem)',
            color: 'var(--dark)',
          }}
        >
          Toys That Make Kids Go{' '}
          <span
            className="bg-clip-text text-transparent"
            style={{
              background: 'linear-gradient(120deg, var(--pink-d), var(--lavender))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Woooah!
          </span>
        </h1>

        <p
          className="text-lg mb-9 leading-relaxed animate-[slideUp_0.7s_0.2s_both]"
          style={{ color: 'var(--mid)' }}
        >
          Kawaii fidgets, squishy pals & novelty wonders — handpicked for curious, playful minds.
          Stress-free fun starts here!
        </p>

        <div className="flex gap-[14px] justify-center flex-wrap animate-[slideUp_0.7s_0.3s_both]">
          <button
            onClick={() => scrollToSection('products')}
            className="btn-kawaii btn-kawaii-primary font-extrabold text-base"
          >
            🛍️ Shop Now
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="btn-kawaii btn-kawaii-secondary font-extrabold text-base"
          >
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
};
